<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig" @onPath="updateCurrentUser"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'PermissionsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    /**
     * @desc Manual update Current User
     * and Routes computed update after
     * VISUAL EFFECT ONLY :)
     */
    updateCurrentUser () {
      this.$store.dispatch('getCurrentAppUser')
    }
  }
}
</script>
